import tw, { styled } from "twin.macro"

export const Overlay = styled.div`
  ${tw`absolute w-full bg-white left-0 lg:hidden box-border py-6 px-8 xl:px-0 max-w-screen-xl font-bold`}

  top: calc(100% + 1px);
  opacity: ${props => (props.menuOpen ? '1' : '0')};
  transform: ${props => props.menuOpen ? 'translateX(0%)' : 'translateX(-100%)'};
  transition: all 0.3s ease;
  box-shadow: 0 2px 2px rgb(0 0 0 / 10%);

  ul{
    ${tw`list-none m-0 p-0`}

    li{
      ${tw``}

      a{
        ${tw`
          py-3 border-0 border-b border-solid border-gray
          no-underline text-black
          block
        `}

        &.text-orange{
          ${tw`text-orange`}
        }

        &.active{
          ${tw`text-lightorange`}
        }
      }

      ul li{
        ${tw`ml-4`}
      }
    }
  }

  ul.menu > li:last-child > a{
      ${tw`pb-0 border-b-0`}
  }

`;
